import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'third-meeting-first-step',
  templateUrl: './third-meeting-first-step.component.html',
  styleUrls: ['../../meeting-form.component.scss']
})
export class ThirdMeetingFirstStepComponent implements OnInit {

  constructor() { }

  ngOnInit(): void {
  }

}
